<app-auth-navbar></app-auth-navbar>
<div class="cxy-page-header cxy-page-header-ngh">
  <div class="d-flex justify-content-center flex-wrap position-absolute" style="top:100px;left:1%" *ngIf="screen_width>996 && offer?.status">
      <div class="col-9 px-3 text-center py-2 offer" style="background-color: #A0BF81;" [innerHTML]="offer.subject">
      </div>
      <div class="col-6 px-2 text-center mt-2 py-2 offer" style="background-color: #266DD3;" [innerHTML]="offer.message">
      </div>
  </div>
  <div class="cxy-page-container w-container">
    <div class="cxy-header-left kenya-header-left">
      <div>
        <div class="text-block-25"><span class="text-span-3">CAD</span> to <span class="text-span-4">NGN</span></div>
      </div>
      <div>
        <h2 class="heading-10"><strong>Send money to Nigeria fast</strong></h2>
      </div>
      <div>
        <div class="text-block-26">Send money “faster and cheaper” to your nephew in Lagos or your friend in Onitsha. There are 100 reasons to send money from Canada to Nigeria instantly with N2Xpress.
          <br></div>
      </div>
    </div>
    <div class="cxy-header-right">
      <div class="calculator-panel">
        <div class="calculator-header">
          <!-- <h1 class="hero-heading">Save more with <br>online money transfers</h1> -->
          <h1 class="hero-heading custom-heroHeading">Send money from Canada to Nigeria</h1>
        </div>
        <div class="form-block w-form">
          <form id="email-form" name="email-form" data-name="Email Form" redirect="https://app.n2xpress.ca/login" data-redirect="https://app.n2xpress.ca/login" class="form">
              <div class="div-block-13">
                  <input [(ngModel)]="amount" (keyup)="onAmountChange($event.target.value)" type="number" style="background:none!important; border:none;" class="text-field w-input m-0 p-3" def="10" autofocus="true" maxlength="256" name="Send" data-name="Send" placeholder="You send" id="currency-send" required="">
                  <div data-hover="" data-delay="0" class="w-dropdown">
                      <div class="dropdown  color-blue radiusr-5" style="height:50px" (click)="common.showDropdown('sourceDrop')" id="sourceDrop"> 
                          <button class="p-0 px-2 bg-transparent h-100 d-flex justify-content-center align-items-center dropdown-button "> 
                              <!-- Country -->
                              {{ countryName }}  <img [src]="'assets/images/' + source + '.png'" class="ml-1" width="22" height="22">
                              <!-- <i class="fas fa-angle-down pl-2"></i> -->
                          </button> 
                          
                          <!-- <div class="dropdown-content w-100"> 
                              <a (click)="onSourceChange('cad','Canada')" class="d-flex justify-content-between align-items-center"> 
                                  Canada
                                  <img alt="CAD" src="assets/images/cad.png" class="ml-1" width="20" height="20">
                              </a> 
                              
                              <a (click)="onSourceChange('usd','USA')" class="d-flex justify-content-between align-items-center"> 
                                  USA
                                  <img alt="USA" src= "assets/images/usd.png" class="ml-1" width="20" height="20"> 
                              </a> 
                              
                          </div>  -->
                      </div>
                      
                  </div>
              </div>
              <div class="rate-panel">
                  <div class="div-block-15"></div>
                  <div class="div-block-16">
                      <div class="div-block-17">
                          <div>
                              <div id="currency-fees" class="fee-figure">{{transactionFees}}</div>
                          </div>
                          <div class="rate-currency">
                              <div id="fees-currency" class="rate-currency-text">{{source.toUpperCase()}}</div>
                          </div>
                          <div class="fee-explainer-text">
                              <div class="explainer-text pl-3">Total fees</div>
                          </div>
                      </div>
                      <div class="div-block-18">
                          <div class="rate-figure">
                              <div id="currency-rate" class="text-block-12">{{conversionRate}}</div>
                          </div>
                          <div class="rate-currency">
                              <div id="exchange-currency" class="rate-currency-text">{{destination_currency.toUpperCase()}}</div>
                          </div>
                          <div class="rate-explainer">
                              <div class="explainer-text">Your exchange rate</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="div-block-13-copy">
                  <input [(ngModel)]="convertedAmount" readonly type="number"  style="background:none!important; border:none;" class="text-field w-input m-0 p-3" maxlength="256" name="Receive" data-name="Receive" placeholder="They receive" id="currency-receive">
                  <div data-hover="" data-delay="0" class="w-dropdown">
                      <div class="dropdown color-blue radiusr-5" style="height:50px" (click)="common.showDropdown('destDrop')" id="destDrop"> 
                          <button class="p-0 px-2 bg-transparent h-100 d-flex justify-content-center align-items-center dropdown-button "> 
                              <!-- Country -->
                              {{ destinationCountryName }} <img [src]="'assets/images/' + destination_currency + '.png'"  class="ml-1" width="22" height="22">
                              <i class="fas fa-angle-down pl-2"></i>
                          </button> 
                          <div class="dropdown-content w-100"> 
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Austria', 15)"> 
                              Austria
                              <img alt="NGN" src="assets/images/austria.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Belgium', 22)"> 
                              Belgium
                              <img alt="NGN" src="assets/images/belgium.png" class="ml-1" width="20" height="20">
                            </a>
                            <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Benin', 24)"> 
                              Benin
                              <img alt="BENIN" src="assets/images/benin.png" class="ml-1" width="20" height="20">
                            </a> 
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Burkina Faso', 35)"> 
                              Burkina Faso
                              <img alt="NGN" src="assets/images/burkinafaso.png" class="ml-1" width="20" height="20">
                            </a> 
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xaf','Cameroon', 38)"> 
                              Cameroon
                              <img alt="NGN" src="assets/images/xaf.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('cny','China', 45)"> 
                              China
                              <img alt="NGN" src="assets/images/cny.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xaf','Congo', 50)"> 
                              Congo
                              <img alt="NGN" src="assets/images/congo.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Cyprus', 57)"> 
                              Cyprus
                              <img alt="NGN" src="assets/images/cyprus.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Ivory Coast', 54)"> 
                              Ivory Coast
                              <img alt="NGN" src="assets/images/ivorycoast.png" class="ml-1" width="20" height="20">
                            </a>
                            
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Estonia', 69)"> 
                              Estonia
                              <img alt="NGN" src="assets/images/estonia.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Finland', 74)"> 
                              Finland 
                              <img alt="NGN" src="assets/images/finland.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','France', 75)"> 
                              France 
                              <img alt="NGN" src="assets/images/france.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Germany', 82)"> 
                              Germany
                              <img alt="NGN" src="assets/images/germany.png" class="ml-1" width="20" height="20">
                            </a>
                            <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ghs','Ghana', 83)"> 
                              Ghana
                              <img alt="GHS" src="assets/images/ghs.png" class="ml-1" width="20" height="20">
                            </a> 
                            
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Greece', 85)"> 
                              Greece
                              <img alt="NGN" src="assets/images/greece.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Guinea-Bissau', 93)"> 
                              Guinea-Bissau
                              <img alt="NGN" src="assets/images/guineabissau.png" class="ml-1" width="20" height="20" style="border-radius:50%">
                            </a>
                            <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('inr','India', 101)"> 
                              India
                              <img alt="INR" src="assets/images/inr.png" class="ml-1" width="20" height="20">
                            </a> 
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('idr','Indonesia', 102)"> 
                              Indonesia
                              <img alt="NGN" src="assets/images/idr.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Ireland', 105)"> 
                              Ireland
                              <img alt="NGN" src="assets/images/ireland.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Italy', 107)"> 
                              Italy
                              <img alt="NGN" src="assets/images/italy.png" class="ml-1" width="20" height="20">
                            </a>
                            <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('kes','Kenya', 113)"> 
                              Kenya
                              <img alt="KES" src="assets/images/kes.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Latvia', 120)"> 
                              Latvia
                              <img alt="NGN" src="assets/images/latvia.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Lithuania', 126)"> 
                              Lithuania
                              <img alt="NGN" src="assets/images/lithuania.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Luxembourg', 127)"> 
                              Luxembourg
                              <img alt="NGN" src="assets/images/luxembourg.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Mali', 134)"> 
                              Mali
                              <img alt="NGN" src="assets/images/mali.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Malta', 135)"> 
                              Malta
                              <img alt="NGN" src="assets/images/malta.png" class="ml-1" width="20" height="20">
                            </a>
                            
                            
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Monaco', 145)"> 
                              Monaco
                              <img alt="NGN" src="assets/images/monaco.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Netherlands', 156)"> 
                              Netherlands
                              <img alt="NGN" src="assets/images/netherlands.png" class="ml-1" width="20" height="20">
                            </a>
                           
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Niger', 160)"> 
                              Niger
                              <img alt="NGN" src="assets/images/niger.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ngn','Nigeria', 161)"> 
                              Nigeria
                              <img alt="NGN" src="assets/images/ngn.png" class="ml-1" width="20" height="20">
                            </a> 
                            <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('php','Philippines', 174)"> 
                              Philippines
                              <img alt="PHP" src="assets/images/php.png" class="ml-1" width="20" height="20">
                            </a> 
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Portugal', 177)"> 
                              Portugal
                              <img alt="NGN" src="assets/images/portugal.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('rwf','Rwanda', 183)"> 
                              Rwanda
                              <img alt="NGN" src="assets/images/spain.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','San Marino', 192)"> 
                              San Marino
                              <img alt="NGN" src="assets/images/sanMarino.png" class="ml-1" width="20" height="20">
                            </a>
                            <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Senegal', 195)"> 
                              Senegal
                              <img alt="XOF" src="assets/images/xof.png" class="ml-1" width="20" height="20">
                            </a> 
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('sgd','Singapore', 199)"> 
                              Singapore
                              <img alt="NGN" src="assets/images/sgd.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Slovakia', 200)"> 
                              Slovakia
                              <img alt="NGN" src="assets/images/slovakia.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Slovenia', 201)"> 
                              Slovenia
                              <img alt="NGN" src="assets/images/slovenia.png" class="ml-1" width="20" height="20">
                            </a>
                            <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('zar','South Africa', 204)"> 
                              South Africa
                              <img alt="ZAR" src="assets/images/zar.png" class="ml-1" width="20" height="20">
                            </a> 
                            
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Spain', 207)"> 
                              Spain
                              <img alt="NGN" src="assets/images/spain.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Togo', 220)"> 
                              Togo
                              <img alt="NGN" src="assets/images/togo.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ugx','Uganda', 229)"> 
                              Uganda
                              <img alt="NGN" src="assets/images/ugx.png" class="ml-1" width="20" height="20">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('gbp','232')"> 
                              United Kingdom
                              <img alt="NGN" src="assets/images/gbp.png" class="ml-1" width="20" height="20" style="border-radius:50%">
                            </a>
                            <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('vnd','Vietnam', 240)"> 
                              Vietnam
                              <img alt="NGN" src="assets/images/vnd.png" class="ml-1" width="20" height="20">
                            </a> 
                          </div> 
                         <!-- <div class="dropdown-content w-100"> 
                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('inr','India', 101)"> 
                      India
                      <img alt="INR" src="assets/images/inr.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ghs','Ghana', 83)"> 
                      Ghana
                      <img alt="GHS" src="assets/images/ghs.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Benin', 24)"> 
                      Benin
                      <img alt="BENIN" src="assets/images/benin.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Senegal', 195)"> 
                      Senegal
                      <img alt="XOF" src="assets/images/xof.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('zar','South Africa', 204)"> 
                      South Africa
                      <img alt="ZAR" src="assets/images/zar.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('php','Philippines', 174)"> 
                      Philippines
                      <img alt="PHP" src="assets/images/php.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('ngn','Nigeria', 161)"> 
                      Nigeria
                      <img alt="NGN" src="assets/images/ngn.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Burkina Faso', 35)"> 
                      Burkina Faso
                      <img alt="NGN" src="assets/images/burkinafaso.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Ivory Coast', 54)"> 
                      Ivory Coast
                      <img alt="NGN" src="assets/images/ivorycoast.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Guinea-Bissau', 93)"> 
                      Guinea-Bissau
                      <img alt="NGN" src="assets/images/guineabissau.png" class="ml-1" width="20" height="20" style="border-radius:50%">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Mali', 134)"> 
                      Mali
                      <img alt="NGN" src="assets/images/mali.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Niger', 160)"> 
                      Niger
                      <img alt="NGN" src="assets/images/niger.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Togo', 220)"> 
                      Togo
                      <img alt="NGN" src="assets/images/togo.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','United Kingdom', 232)"> 
                      United Kingdom
                      <img alt="NGN" src="assets/images/gbp.png" class="ml-1" width="20" height="20" style="border-radius:50%">
                    </a>
                    <a  class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('kes','Kenya', 113)"> 
                      Kenya
                      <img alt="KES" src="assets/images/kes.png" class="ml-1" width="20" height="20">
                    </a> 
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Austria', 15)"> 
                      Austria
                      <img alt="NGN" src="assets/images/austria.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Belgium', 22)"> 
                      Belgium
                      <img alt="NGN" src="assets/images/belgium.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Cyprus', 57)"> 
                      Cyprus
                      <img alt="NGN" src="assets/images/cyprus.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Estonia', 69)"> 
                      Estonia
                      <img alt="NGN" src="assets/images/estonia.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Finland', 74)"> 
                      Finland 
                      <img alt="NGN" src="assets/images/finland.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','France', 75)"> 
                      France 
                      <img alt="NGN" src="assets/images/france.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Germany', 82)"> 
                      Germany
                      <img alt="NGN" src="assets/images/germany.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Greece', 85)"> 
                      Greece
                      <img alt="NGN" src="assets/images/greece.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Ireland', 105)"> 
                      Ireland
                      <img alt="NGN" src="assets/images/ireland.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Italy', 107)"> 
                      Italy
                      <img alt="NGN" src="assets/images/italy.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Latvia', 120)"> 
                      Latvia
                      <img alt="NGN" src="assets/images/latvia.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Lithuania', 126)"> 
                      Lithuania
                      <img alt="NGN" src="assets/images/lithuania.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Luxembourg', 127)"> 
                      Luxembourg
                      <img alt="NGN" src="assets/images/luxembourg.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Malta', 135)"> 
                      Malta
                      <img alt="NGN" src="assets/images/malta.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Monaco', 145)"> 
                      Monaco
                      <img alt="NGN" src="assets/images/monaco.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Netherlands', 156)"> 
                      Netherlands
                      <img alt="NGN" src="assets/images/netherlands.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Portugal', 177)"> 
                      Portugal
                      <img alt="NGN" src="assets/images/portugal.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','San Marino', 192)"> 
                      San Marino
                      <img alt="NGN" src="assets/images/sanMarino.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Slovakia', 200)"> 
                      Slovakia
                      <img alt="NGN" src="assets/images/slovakia.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Slovenia', 201)"> 
                      Slovenia
                      <img alt="NGN" src="assets/images/slovenia.png" class="ml-1" width="20" height="20">
                    </a>
                    <a *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('eur','Spain', 207)"> 
                      Spain
                      <img alt="NGN" src="assets/images/spain.png" class="ml-1" width="20" height="20">
                    </a>
                    
                  </div>  -->
                      </div>
                      
                  </div>
              </div>
          </form>
          <div class="w-form-done">
              <div>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
              <div>Oops! Something went wrong while submitting the form.</div>
          </div>
      </div>
      <a  id="send-money-button" style="background:#266DD3;" routerLink="/dashboard" class="calculator-button w-button w-button-sm14">Send money across borders, the easy way<span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span></a>
      <small *ngIf="!common.isIos" class="text-center mt-3 text10 grey-text">Also available for</small>
      <div *ngIf="!common.isIos" class="text-center">
          <a target="blank" href="https://play.google.com/store/apps/details?id=com.n2xpress.app"> 
              <img  src="assets/images/google-play.png" class="playStore-img " alt="">
          </a>
          <!-- <p-dialog header="" [closable]="false" [(visible)]="common.visibleIos" [style]="common.respwidth" [modal]="true">
            <h1 class="text-center blue">iOS app coming soon</h1>
            <ng-template pTemplate="footer">
              <p-button icon="pi pi-check" (click)="visibleIos=false" label="Ok" styleClass="p-button-text"></p-button>
              </ng-template>
          </p-dialog> -->
          <a class="cursor-pointer" href="https://apps.apple.com/in/app/n2xpress-money-transfer/id1570971775" target="blank"> 
            <img  src="assets/images/apple_store.png" class="appleStore-img  m-1" alt="">
          </a>
      </div>
      </div>
    </div>
  </div>
</div>
<div class="" *ngIf="!(screen_width>996) && offer?.status">
  <div class="d-flex justify-content-center flex-wrap">
      <div class="col-11 px-3 text-center py-2 offer" style="background-color: #A0BF81;color:white" [innerHTML]="offer.subject">
      </div>
      <div class="col-8 px-3 text-center mt-2 py-2 offer" style="background-color: #266DD3;color:white" [innerHTML]="offer.message">
      </div>
  </div>
</div>
<div class="benefits-heading-section">
  <div class="w-container">
    <div class="testimonial-header">
      <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="benefits-chop mb-0">
      <div class="benefits-heading"><strong>Benefits of sending money from Canada to <br/> Nigeria through N2Xpress
      </strong></div>
    </div>
  </div>
</div>
<div class="benefits-section">
  <div class="w-container">
    <div class="benefits-body text-center d-flex flex-wrap justify-content-center">
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="pink blue">Send money to any bank in Nigeria</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Now transfer money directly to any bank account in India. You can transfer money to India for family needs, investments, EMIs, loan payments and property purchases. With best exchange rates and zero fees, meet all utilities. save more and do more.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="yellow blue">Multiple sending options<br></div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Sending money through multiple options is an advantage in itself. Just imagine you have several options to choose from and you never fail to meet the deadline. Switch to N2Xpress and use money sending and receiving options and never miss pleasing your loved ones. Get the best exchange rate and on-time transfer at your fingertips.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="purple blue">The lowest transfer fees</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">When it comes to money transfers, everyone expects to transfer at affordable rates. N2Xpress has revolutionised the money transfer industry with its unique features - you always get the best rates available.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="green blue">Transfer money instantly</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Sign up, verify your account, and get ready for transact. All it takes is just a few taps. The money is sent instantly overseas, transferred to the recipient.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="purple blue">Competitive exchange rates</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Our exchange rate calculator carefully compares rates and fees and gives you great exchange rates. We add significant value to your transfer and keep your loved ones happy.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="green blue">24/7 customer support </div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Don't lose sight of your money. Our customer care executives are available 24/7 to help you out. Email us and you will receive a response the same day.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box">
        <div class="cxy-benefit-header">
          <div class="yellow blue">Secure and safe</div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">You can trust us with your hard-earned money while sending money to India. We offer bank-grade security without the slow pace and high fees. Using the highest security and compliance processes, your money and personal details are safe with us. We ensure the safe delivery of your money.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="testimonial-section pt-0">
  <div class="instruction-container w-container">
    <div class="instruction-header"><img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
      <div class="section-header-text instructions blue">Steps to send money to <br />Nigeria online
      </div>
    </div>
    <div class="upper-instructions d-flex flex-wrap">
      <div class="instruction-card _1 col-12 col-md-3 m-0 bg-transparent">
        <div class="instruction-heading _1 green-royal">1.<br /> Create your free account
        </div>
        <div class="instrucrtion-body">Register online and enter your details for ID verification. Make sure what you enter matches exactly with your identification documents.
        </div>
      </div>
      <div class="instruction-card _2 col-12 col-md-3 m-0 bg-transparent">
        <div class="instruction-heading _2 green-royal">2.<br /> Choose a method
        </div>
        <div class="instrucrtion-body">Select the currency, country, person, and amount. We’ll show you the exchange rate and total fees upfront for hassle-free transfer to the recipient's account.
        </div>
      </div>
      <div class="instruction-card _3 col-12 col-md-3 m-0 bg-transparent">
        <div class="instruction-heading _3 green-royal">3.<br /> Input receiver details
        </div>
        <div class="instrucrtion-body">Tell us the details of the person receiving the money. Make sure it matches their identification documents exactly. Don't worry about all the information you enter as we keep every detail confidential.
        </div>
      </div>
      <div class="instruction-card _4 col-12 col-md-3 m-0 bg-transparent">
        <div class="instruction-heading _4 green-royal">4.<br /> Confirm and send</div>
        <div class="instrucrtion-body">Double-check everything is correct and send your money to Nigeria. That’s it. We’ll take care of the rest and tell you when it has arrived. Through email or text, we will notify you.
        </div>
      </div>
    </div>
    <!-- <div class="lower-instructions"> -->
    <!-- <div class="instruction-card _3 col-3">
      <div class="instruction-heading _3">3. Input receiver details
      </div>
      <div class="instrucrtion-body">Tell us the details of the person receiving the money. Make sure it matches their identification documents exactly. Don't worry about all the information you enter as we keep every detail confidential.
      </div>
    </div>
    <div class="instruction-card _4 col-3">
      <div class="instruction-heading _4">4. Confirm and send</div>
      <div class="instrucrtion-body">Double-check everything is correct and send your money to Nigeria. That’s it. We’ll take care of the rest and tell you when it has arrived. Through email or text, we will notify you.
      </div>
    </div> -->
    <!-- </div> -->
    <!-- <div class="call-to-action-button">
      <a id="sign-up-button-on-page" routerLink="/register" class="button-3 w-button">Sign up</a>
    </div> -->
  </div>
</div>
<div class="py-5">
  <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto">
      Sign up 
      <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>
  </a>
</div>
<div class="cad-to-inr-header-container">
  <h1 class="cad-to-inr-heading"><strong>How to send from Canada to Nigeria at lower transfer fees?</strong></h1>
</div>
<div class="batching-section">
  <div class="batching-container w-container">
    <div class="cxy-right">
      <div class="cad-to-inr-description-container">
        <div class="cad-to-inr-description">We compare and give you the best money transfer rates from Canada to Nigeria. <br>‍<br>To transfer your Canadian dollars to a bank account in Nigerian Naira (NGN) in Nigeria, the cheapest provider at the moment is N2Xpress with transfer fees at just 1% and a very competitive CAD-NGN conversion rate. Send money to Nigeria the smart way.<br></div>
      </div>
    </div>
  </div>
</div>
<div class="text-center">
  <small *ngIf="!common.isIos" class="text-left mt-3 text10 grey-text">also available for</small>
  <div *ngIf="!common.isIos" class="text-left text-center">
      <a target="blank" href="https://play.google.com/store/apps/details?id=com.n2xpress.app"> 
      <img  src="assets/images/google-play.png" class="playStore-img-large " alt="">
      </a>
      <a class="cursor-pointer" href="https://apps.apple.com/in/app/n2xpress-money-transfer/id1570971775" target="blank"> 
        <img  src="assets/images/apple_store.png" class="appleStore-img-large  m-1" alt="">
      </a>
  </div>
</div>
<div class="n2xpress-help-heading instruction-header"><img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
  <div class="section-header-text instructions blue">
    <strong>
      How N2Xpress helps in three ways?
    </strong>
  </div>
</div>
<div class="n2xpress-help">
  <div class="w-container">
    <div class="benefits-body n2xpress-help-body">
      <div class="cxy-benefit-box w-100">
        <div class="cxy-benefit-header">
          <div class="pink blue"><strong>Users</strong></div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Send money to Nigeria using N2Xpress. Meet the needs of your loved ones instantly. Pay utilities and send much more than money. Send love and care.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box w-100">
        <div class="cxy-benefit-header">
          <div class="pink blue"><strong >Businesses</strong></div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">It's time for businesses to make international payments more profitable and easy. Easier fund transfer helps businesses do international transfers hassle-free.
          </div>
        </div>
      </div>
      <div class="cxy-benefit-box w-100">
        <div class="cxy-benefit-header">
          <div class="pink blue"><strong >Partners </strong></div>
        </div>
        <div class="benefit-body">
          <div class="benefit-body-text gray">Reach highly valuable remittance audiences easily through marketplaces created by money transfer providers like N2Xpress
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container-fluid flags-custom">
  <div class="">
      <div class="currency-header"><img alt="Send money with N2Xpress" src="assets/images/Testimonial-Chop.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2">
          <div class="section-header-text new-flag-section">Currencies</div>
      </div>
      <div class="custom-currency-intro text-center">
          <div class="text-center new-flag-section">We support popular currencies for sending money from Canada and The United States.
              <br></div>
          </div>
          <div class="row mt-5 mx-0">
              <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-xof">
                  <img src="assets/images/benin-flag.png" alt="Benin">
                  <div class="row">
                      <p class="country-names country-benin pt-1">Benin</p>
                  </div>
                  <div class="row">
                      <small class="country-currency">CFA</small>
                  </div>
              </div>
              <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-ghs">
                  <img alt="GHANA" src="assets/images/ghana-flag.png" alt="Ghana">
                  <div class="row">
                      <p class="country-names country-ghana pt-1">Ghanaian Cedi</p>
                  </div>
                  <div class="row">
                      <small class="country-currency">GHS</small>
                  </div>
              </div>
              <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-inr">
                  <img alt="INDIA" src="assets/images/india-flag.PNG" alt="India">
                  <div class="row">
                      <p class="country-names country-india pt-1">Indian Rupee</p>
                  </div>
                  <div class="row">
                      <small class="country-currency">INR</small>
                  </div>
              </div>
              <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-kes">
                  <img alt="KENYA" src="assets/images/kenya-flag.PNG" alt="Kenya">
                  <div class="row">
                      <p class="country-names country-ghana pt-1">Kenyan Shilling</p>
                  </div>
                  <div class="row">
                      <small class="country-currency">KES</small>
                  </div>
              </div>
          </div>
          <div class="row second-row-flags mx-0 justify-content-center">
              <div class="col-md-3 col-12 flags-section mt-3 cursor-pointer" routerLink="/cad-to-ngn">
                  <img alt="NIGERIA" src="assets/images/nigeria-flag.PNG" alt="Nigeria">
                  <div class="row">
                      <p class="country-names country-ghana pt-1">Nigerian Naira</p>
                  </div>
                  <div class="row">
                      <small class="country-currency">NGN</small>
                  </div>
              </div>
              <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-php">
                  <img alt="PHILIPPINE" src="assets/images/philippine-flag.PNG" alt="Philippine">
                  <div class="row">
                      <p class="country-names country-ghana pt-1">Philippine Peso</p>
                  </div>
                  <div class="row">
                      <small class="country-currency">PHP</small>
                  </div>
              </div>
              <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-xof">
                  <img alt="SENEGAL" src="assets/images/senegal-flag.png" alt="">
                  <div class="row">
                      <p class="country-names country-senegal pt-1">Senegal</p>
                  </div>
                  <div class="row">
                      <small class="country-currency">CFA</small>
                  </div>
              </div> 
              <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-zar">
                  <img alt="SOUTH AFRICA RAND" src="assets/images/sa-flag.PNG" alt="">
                  <div class="row">
                      <p class="country-names country-sa pt-1">South Africa Rand</p>
                  </div>
                  <div class="row">
                      <small class="country-currency">ZAR</small>
                  </div>
              </div>
          </div>
  </div>
</div> -->
<div class="container-fluid flags-custom pb-5 pt-5 text-center ">
  <img alt="Send money with N2Xpress" src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0 my-2">
  <div class="text-center">
    
    <div class="currency-header py-2 mb-0">
      <div class="section-header-text new-flag-section" style="color:#2371D3">
          Currencies
      </div>
    </div>
    <div class="custom-currency-intro text-center">
      <div class="text-center new-flag-section my-2">
        We support popular currencies for sending money from Canada and the United States of America. 

        <br></div>
      </div>
      <div class="row mt-5 mx-0">
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="SOUTH AFRICA RAND" src="assets/images/sa-flag.PNG" alt="" class="cursor-pointer" routerLink="/cad-to-zar">
          <div class="row">
            <p class="country-names country-sa pt-1 cursor-pointer" routerLink="/cad-to-zar">South Africa Rand</p>
          </div>
          <div class="row">
            <small class="country-currency">ZAR</small>
          </div>
        </div>
        <div class="col-md-3 col-12 flags-section mt-3 " >
          <img alt="NIGERIA" src="assets/images/nigeria-flag.PNG" alt="Nigeria" class="cursor-pointer" routerLink="/cad-to-ngn">
          <div class="row">
            <p class="country-names country-ghana pt-1 cursor-pointer" routerLink="/cad-to-ngn">Nigerian Naira</p>
          </div>
          <div class="row">
            <small class="country-currency">NGN</small>
          </div>
        </div>
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="PHILIPPINE" src="assets/images/philippine-flag.PNG" alt="Philippine" class="cursor-pointer" routerLink="/cad-to-php">
          <div class="row">
            <p class="country-names country-ghana pt-1 cursor-pointer" routerLink="/cad-to-php">Philippine Peso</p>
          </div>
          <div class="row">
            <small class="country-currency">PHP</small>
          </div>
        </div>
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="KENYA" src="assets/images/kenya-flag.PNG" alt="Kenya" class="cursor-pointer" routerLink="/cad-to-kes">
          <div class="row">
            <p class="country-names country-ghana pt-1 cursor-pointer" routerLink="/cad-to-kes">Kenyan Shilling</p>
          </div>
          <div class="row">
            <small class="country-currency">KES</small>
          </div>
        </div>
        
      </div>
      <div class="row second-row-flags mx-0 justify-content-center">
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="INDIA" src="assets/images/india-flag.PNG" alt="India" class="cursor-pointer" routerLink="/cad-to-inr">
          <div class="row">
            <p class="country-names country-india pt-1 cursor-pointer" routerLink="/cad-to-inr">Indian Rupee</p>
          </div>
          <div class="row">
            <small class="country-currency">INR</small>
          </div>
        </div>
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="SENEGAL" src="assets/images/xof-flag.png" alt="" class="cursor-pointer" routerLink="/cad-to-xof">
          <div class="row">
            <p class="country-names country-senegal pt-1 px-0 text-center w-100 cursor-pointer" routerLink="/cad-to-xof">West African CFA Franc</p>
          </div>
          <div class="row">
            <small class="country-currency">CFA</small>
          </div>
        </div> 
        <div class="col-md-3 col-12 flags-section  mt-3 " >
          <img alt="GHANA" src="assets/images/ghana-flag.png" alt="Ghana" class="cursor-pointer" routerLink="/cad-to-ghs">
          <div class="row">
            <p class="country-names country-ghana pt-1 cursor-pointer" routerLink="/cad-to-ghs">Ghanaian Cedi</p>
          </div>
          <div class="row">
            <small class="country-currency">GHS</small>
          </div>
        </div>
        <!-- <div class="col-md-3 col-12 flags-section  mt-3 cursor-pointer" routerLink="/cad-to-xof">
          <img src="assets/images/benin-flag.png" alt="Benin">
          <div class="row">
            <p class="country-names country-benin pt-1">Benin</p>
          </div>
          <div class="row">
            <small class="country-currency">CFA</small>
          </div>
        </div>
        
        
         -->
         <!-- <div class="col-md-3 col-12 flags-section  mt-3" >
          <img src="assets/images/mexico-flag.png" alt="Mexico" routerLink="/cad-to-xof" class="cursor-pointer">
          <div class="row">
            <p class="country-names country-benin pt-1 px-0 text-center w-100 cursor-pointer" routerLink="/cad-to-xof">Mexican Peso</p>
          </div>
          <div class="row">
            <small class="country-currency">MXN</small>
          </div>
        </div> -->

        

      </div>
      
    </div>
</div>
<div class="">
  <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 my-5 text-white calculator-button d-block mx-auto">
      Send money now 
      <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>
  </a>
</div>
  <div class="send-money-section">
    <div class="instruction-header send-money-heading-section"><img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
      <div class="section-header-text instructions blue"><strong>Send money to Nigeria</strong></div>
    </div>
    <div class="box-wrapper">
      <p class="send-money-paragraph-section px-5">Money transfers to Nigeria are not new. Remittances have existed for a long time but with technological advancement and mobile phones, the experience has become a lot faster and affordable.
         <br>‍<br>According to World Bank data, Nigeria is on the list of the largest receivers of remittances. In 2018, a total of US$23.63 billion migrant remittance flow to Nigeria. Nigeria's remittance inflows were also 7.4 times larger than the net official development assistance (foreign aid) received in 2017. From this, you can estimate what is remittance growth and it will continue to be on this track in coming years. Also, Canada stands in fourth position as the largest sender of remittances around the world after the USA, UK, and UAE.
        <br><br>N2Xpress has simplified the transfer process through instant online money transfers. You can now send money from Canada to Nigeria using a variety of methods including cards, cheques, bank transfers, and mobile airtime top-ups.
        <br><br>The choice is up to you, but we’ll make sure it’s fast, convenient, and secure. We always show you the CAD to NGN exchange rates and low fees upfront, without hidden charges. Ever.
      </p>
    </div>
  </div>
  <div>
    <a id="send-money-button" style="background:#266DD3;border-radius: 0;" routerLink="/register" class="col-10 col-md-3 px-4 py-2 mb-3 text-white calculator-button d-block mx-auto my-5">
        Sign up 
      <span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span>

    </a>
  </div>
  <div class="faq-section text-center">
    <img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
    <div class="box-wrapper">
      <div class="faq-heading blue pt-0">Frequently Asked Questions</div>
      <div class="card border-0">
        <div class="card-header border-0 bg-transparent" id="headingTwo">
          <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1">What is overseas money transfer? 
            <i class="fas fa-chevron-down ml-auto"></i></h3>
          </div>
          <div id="collapse1" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
            <p class="paragraph-2">An overseas money transfer is sending money abroad from the resident country to any overseas country. You can send money to recipients to meet your urgent business or personal needs. It serves various purposes like medical treatment abroad, supporting close relatives, private visits, paying bills, etc. A fast way to transfer money to your loved ones at affordable rates when needed most is using N2Xpress.</p>
          </div>
        </div>
        <div class="accordion-item">
          <div class="card-header border-0 bg-transparent" id="headingTwo">
            <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapse2">How does N2Xpress work?
              <i class="fas fa-chevron-down ml-auto"></i></h3>
            </div>
            <div id="collapse2" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">N2Xpress is a digital remittance platform which works on the concept of “Save More &amp; Do More”. We are making it easier to send money globally and provide a world class service that is hassle free. We save remitters money by providing competitive exchange rate and transfer fees.</p>
            </div>
          </div>
          <div class="accordion-item">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
              <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">Is it safe to send money online through N2Xpress?  <i class="fas fa-chevron-down ml-auto"></i></h3>
              
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">At N2Xpress due care is taken and precaution is exercised to maintain high-level security. We use a compliance process and highest security while transferring. It is important to ensure safety first and to keep information of both the remitter and recipient safe and secure. Check data entered twice and select the transfer option. Stay safe and alert of fraud - in case you receive anything irrelevant related to our service, mail us with details and we will look into it.<br></p>
            </div>
          </div>
          <div class="accordion-item">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
              <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapse3">What is N2Xpress and how to transfer money to Nigeria?  <i class="fas fa-chevron-down ml-auto"></i></h3>
              
            </div>
            <div id="collapse3" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">N2Xpress is an online money transfer platform which enables you to send money from Canada to anywhere in Nigeria. All you have to do is register on <a routerLink="/">www.n2xpress.com</a> and create a free account. Submit simple verification documents and remit online in just a few taps.</p>
            </div>
          </div>
          <div class="accordion-item">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
              <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse4" aria-expanded="false" aria-controls="collapse4">How much does it cost to transfer money to Nigeria?  <i class="fas fa-chevron-down ml-auto"></i></h3>
              
            </div>
            <div id="collapse4" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">Send money in CAD to NGN with a flat fee on different amounts and transactions. N2Xpress shows total cost upfront and so there are no hidden charges or cost. Before transacting, check our minimum transfer fee on every transaction. Maximum limit per transaction is $2999.<br>Transfer fee structure<br>‍<br>$1000             - $5<br>$1001-$1999  - $5<br>$2000-$2999   - $15<br>‍<br></p>
            </div>
          </div>
          <div class="accordion-item">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
              <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse5" aria-expanded="false" aria-controls="collapse5">Best online platform to transfer money from Canada to Nigeria?<br>  <i class="fas fa-chevron-down ml-auto"></i></h3>
              
            </div>
            <div id="collapse5" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">When you want to transfer money from Canada to Nigeria, then focus on these key points.<br></p>
              <ul role="list">
                <li>Good exchange rate</li>
                <li>Low transfer fee</li>
                <li>Fastest money transfer</li>
                <li>Multiple options for transfer</li>
                <li>Secure and guaranteed money transfer<br></li>
              </ul>
              <p class="paragraph-2">When you are looking to transfer Canadian Dollar (CAD) to Nigerian Naira (NGN) you should keep a few things in mind. There are a number of options available but it’s your call to choose the best online remittance platform with the best currency converter exchange rates.<br></p>
            </div>
          </div>
          <div class="accordion-item">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
              <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse6" aria-expanded="false" aria-controls="collapse6">Best rate to transfer CAD and NGN?  <i class="fas fa-chevron-down ml-auto"></i></h3>
              
            </div>
            <div id="collapse6" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">For somebody to transfer to Nigeria, N2Xpress offers the best deal to transfer Canadian dollar to Nigerian Naira. CAD-NGN conversion rate. Check out the currency converter at the top of the page to find out today’s rate.<br></p>
            </div>
          </div>
          <div class="accordion-item">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
              <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse7" aria-expanded="false" aria-controls="collapse7">How can I wire money transfer from Canada to Nigeria?  <i class="fas fa-chevron-down ml-auto"></i></h3>
              
            </div>
            <div id="collapse7" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">Stay connected with your loved ones with N2Xpress by wiring money transfer from Canada to Nigeria using a debit card, credit card or airtime top up.<br></p>
            </div>
          </div>
          <div class="accordion-item">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
              <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse8" aria-expanded="false" aria-controls="collapse8">How long does it take to send money to Nigeria?<br>  <i class="fas fa-chevron-down ml-auto"></i></h3>
              
            </div>
            <div id="collapse8" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">It mostly depends on:<br></p>
              <ul role="list">
                <li>Public holidays or weekends</li>
                <li>Countries you send from</li>
                <li>Security checks</li>
                <li>Payment Methods</li>
              </ul>
              <p class="paragraph-2">N2Xpress is the cheapest and fastest way to send money to Nigeria from Canada. <a routerLink="/register">Sign Up</a><br><br></p>
            </div>
          </div>
          <div class="accordion-item">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
              <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer blue" data-toggle="collapse" data-target="#collapse9" aria-expanded="false" aria-controls="collapse9">Which is the fastest and cheapest mode of money transfer to Nigeria from Canada?<br>  <i class="fas fa-chevron-down ml-auto"></i></h3>
              
            </div>
            <div id="collapse9" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <p class="paragraph-2">When it comes to international money transfer, you always look for the fastest and most convenient options. N2Xpress meets both the criteria of being the fastest and the cheapest mode of money transfer from Canada to Nigeria. The banks are not the best way to transfer money as they are most expensive in terms of fees and exchange rates.<br></p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="w-embed w-iframe">
        <!--  Google Tag Manager (noscript)  -->
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NT3DRQ6" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
        <!--  End Google Tag Manager (noscript)  -->
        <noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=126238879075083&ev=PageView&noscript=1"></noscript>
      </div>
      
      <style>
        .accordion-item-trigger .accordion-icon{
          transition: all 0.2s ease-out; 
        }
        .accordion-item-trigger + .accordion-item-content{
          transition: all 0.2s ease-out; 
        }
      </style>
      
      <app-home-footer></app-home-footer>